/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface AssessmentTaskType
 */
export interface AssessmentTaskType {
  /**
   *
   * @type {number}
   * @memberof AssessmentTaskType
   */
  tabularMl: number;
  /**
   *
   * @type {number}
   * @memberof AssessmentTaskType
   */
  singleTurnChat: number;
  /**
   *
   * @type {number}
   * @memberof AssessmentTaskType
   */
  textGeneration: number;
  /**
   *
   * @type {number}
   * @memberof AssessmentTaskType
   */
  informationExtraction: number;
  /**
   *
   * @type {number}
   * @memberof AssessmentTaskType
   */
  conversationalAgent: number;
  /**
   *
   * @type {number}
   * @memberof AssessmentTaskType
   */
  voiceAgent: number;
  /**
   *
   * @type {number}
   * @memberof AssessmentTaskType
   */
  concierge: number;
}

/**
 * Check if a given object implements the AssessmentTaskType interface.
 */
export function instanceOfAssessmentTaskType(value: object): value is AssessmentTaskType {
  if (!('tabularMl' in value) || value['tabularMl'] === undefined) return false;
  if (!('singleTurnChat' in value) || value['singleTurnChat'] === undefined) return false;
  if (!('textGeneration' in value) || value['textGeneration'] === undefined) return false;
  if (!('informationExtraction' in value) || value['informationExtraction'] === undefined) return false;
  if (!('conversationalAgent' in value) || value['conversationalAgent'] === undefined) return false;
  if (!('voiceAgent' in value) || value['voiceAgent'] === undefined) return false;
  if (!('concierge' in value) || value['concierge'] === undefined) return false;
  return true;
}

export function AssessmentTaskTypeFromJSON(json: any): AssessmentTaskType {
  return AssessmentTaskTypeFromJSONTyped(json, false);
}

export function AssessmentTaskTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssessmentTaskType {
  if (json == null) {
    return json;
  }
  return {
    tabularMl: json['tabular_ml'],
    singleTurnChat: json['single_turn_chat'],
    textGeneration: json['text_generation'],
    informationExtraction: json['information_extraction'],
    conversationalAgent: json['conversational_agent'],
    voiceAgent: json['voice_agent'],
    concierge: json['concierge'],
  };
}

export function AssessmentTaskTypeToJSON(value?: AssessmentTaskType | null): any {
  if (value == null) {
    return value;
  }
  return {
    tabular_ml: value['tabularMl'],
    single_turn_chat: value['singleTurnChat'],
    text_generation: value['textGeneration'],
    information_extraction: value['informationExtraction'],
    conversational_agent: value['conversationalAgent'],
    voice_agent: value['voiceAgent'],
    concierge: value['concierge'],
  };
}
